import { render, staticRenderFns } from "./Support.vue?vue&type=template&id=7630e7a2&scoped=true&"
import script from "./Support.vue?vue&type=script&lang=js&"
export * from "./Support.vue?vue&type=script&lang=js&"
import style0 from "./Support.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Support.vue?vue&type=style&index=1&id=7630e7a2&scoped=true&lang=css&"
import style2 from "./Support.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7630e7a2",
  null
  
)

export default component.exports